<template>
  <div id="tab3">
    <h1>Tab 3</h1>
    <p>Example tab menu 3 case is active selected.</p>
  </div>
</template>

<script>
export default {
  name: 'Tab3'
}
</script>